import useRouter from 'use-react-router';

import { LoginType } from '@mm/state/controllers/SessionController';

import { routes } from '../../routes';
import { Routes } from '../../../../routes/top-level-routes';

export const useAuthBtn = (type?: LoginType) => {
  const { match } = useRouter();

  const isSignIn = match.path.includes(routes.signin.path);
  const isLogIn = match.path.includes(Routes.login.path);
  const isSignUp = match.path.includes(routes.signup.path);
  const isResetPassword = match.path.includes(routes.resetPassword.path);

  const authBtnText = isSignIn ? 'SIGN UP' : 'SIGN IN';
  const authLinkDestination = isSignIn
    ? routes.signup.compile(type)
    : routes.signin.compile(type);

  return {
    authBtnText,
    authLinkDestination,
    isSignUp,
    isSignIn,
    isLogIn,
    isResetPassword,
  };
};
